import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './ErrorBoundary.module.scss';

function ErrorFallback({
  variant = 'page',
  onReset,
  showDetails = false,
  error = null,
}) {
  const navigate = useNavigate();
  const isGlobal = variant === 'global';

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoDashboard = () => {
    navigate('/dashboard');
    if (onReset) onReset();
  };

  return (
    <div
      className={`${styles.fallback} ${
        isGlobal ? styles.fallbackGlobal : styles.fallbackPage
      }`}
      role="alert"
    >
      <div className={styles.fallbackContent}>
        <h2 className={styles.title}>Something went wrong</h2>
        <p className={styles.message}>
          {isGlobal
            ? 'The application ran into an unexpected error. You can reload the page or return to the dashboard.'
            : 'This page could not be displayed because of an unexpected error. The sidebar and header are still available.'}
        </p>
        {showDetails && error?.message && (
          <pre className={styles.errorDetails}>{error.message}</pre>
        )}
        <div className={styles.actions}>
          {onReset && (
            <button type="button" className={styles.btnPrimary} onClick={onReset}>
              Try again
            </button>
          )}
          <button type="button" className={styles.btnSecondary} onClick={handleGoDashboard}>
            Go to dashboard
          </button>
          {isGlobal && (
            <button type="button" className={styles.btnSecondary} onClick={handleReload}>
              Reload page
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

ErrorFallback.propTypes = {
  variant: PropTypes.oneOf(['global', 'page']),
  onReset: PropTypes.func,
  showDetails: PropTypes.bool,
  error: PropTypes.instanceOf(Error),
};

export default ErrorFallback;
